
// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  TOOLS_SHARE: '[data-fragment="NewsDetail.toolsShare"]',
  TOOLS_LIKE: '[data-fragment="NewsDetail.toolsLike"]',
  NEWS_GET_SI: '/api/bn-news/bnNews/adam/container/getStatisticalInfo',
  NEWS_PUT_SI: '/api/bn-news/bnNews/adam/container/putStatisticalInfo',
};

export default class NewsDetail extends WebComponent {
  constructor(props) {
    super(props);
    this.props = props;
  }

  didMount() {
    this.toolShareElement = document.querySelector(fragments.TOOLS_SHARE);
    this.toolLikeElement = document.querySelector(fragments.TOOLS_LIKE);

    if (this.toolLikeElement) {
      const newsId = this.element.getAttribute('data-id');
      const isActive = localStorage.getItem(`${newsId}_like`);
      if (isActive === 'true') {
        this.toolLikeElement.classList.add('active');
      }
      this.toolLikeElement.addEventListener('click', this.handleClickOnToolsLike.bind(this));
    }

    if (this.toolShareElement) {
      const dataUrl = this.element.getAttribute('data-url');
      const dataTitle = document.querySelector('h1');
      // eslint-disable-next-line no-undef
      if (navigator.share) {
        const shareData = {
          title: dataTitle ? dataTitle.innerText : '',
          text: '',
          // eslint-disable-next-line no-undef
          url: window.location.origin + dataUrl,
        };
        this.toolShareElement.addEventListener('click', e => this.handleClickOnToolsShare(e, shareData));
      } else {
        this.toolShareElement.classList.add('hidden');
      }
    }

    this.initItemsStatistics();
  }

  initItemsStatistics = async () => {
    const newsId = this.element.getAttribute('data-id');
    // eslint-disable-next-line no-undef
    fetch(`${window.location.origin + fragments.NEWS_GET_SI}?news_id=${newsId}`).then((response) => {
	  const contentType = response.headers.get('content-type');
	  if (!contentType || !contentType.includes('application/json')) {
		  return null;
	  }
      response.json().then(r => this.showToolsCount(r.like_count));
    });
  }

  showToolsCount = (count) => {
	  const likeCountElement = document.querySelector('.page-top__tools-count');
	  likeCountElement.classList.remove('hidden');
	  // eslint-disable-next-line radix
	  if (count != null) {
		  likeCountElement.innerText = count;
	  } else {
		  const likeCount = parseInt(likeCountElement.innerText);
		  if (likeCountElement.parentElement.classList.contains('active')) {
			  likeCountElement.innerText = likeCount + 1;
		  } else {
			  likeCountElement.innerText = likeCount - 1;
		  }
	  }
	  if (likeCountElement.innerText === '0') {
		  likeCountElement.classList.add('hidden');
	  }
  }

  handleClickOnToolsShare = async (e, shareData) => {
	  try {
      // eslint-disable-next-line no-undef
      await navigator.share(shareData);
	  const newsId = this.element.getAttribute('data-id');
	  fetch(`${window.location.origin + fragments.NEWS_GET_SI}?news_id=${newsId}`).then((response) => {
		  // eslint-disable-next-line no-mixed-spaces-and-tabs
		  const contentType = response.headers.get('content-type');
		  if (!contentType || !contentType.includes('application/json')) {
			  const bodyData = {
				  news_id: newsId,
				  share_count: 1,
			  };
			  this.putData(bodyData);
			  return null;
		  }
			  response.json().then((r) => {
				  const shareCount = parseInt(r.share_count ? r.share_count : 0);
				  if (shareCount >= 0) {
					  const bodyData = {
						  id: r.id,
						  share_count: shareCount + 1,
					  };
					  this.putData(bodyData);
				  }
			  });
	  });

	  window.dataLayer.push({
        event: 'click_icon',
        click_icon: {
          name: 'share',
          area: 'body',
          url: window.location.href,
          type: 'vlastovka',
        },
        _clear: true,
	  });
    } catch (err) {
      console.log(`Error: ${err}`);
    }
  }

  handleClickOnToolsLike = (e) => {
    e.preventDefault();
    const isActive = document.querySelector(fragments.TOOLS_LIKE).classList.toggle('active');
    const newsId = this.element.getAttribute('data-id');
    localStorage.setItem(`${newsId}_like`, isActive);
    // eslint-disable-next-line no-undef
    fetch(`${window.location.origin + fragments.NEWS_GET_SI}?news_id=${newsId}`).then((response) => {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const bodyData = {
          news_id: newsId,
          like_count: 1,
        };
        this.putData(bodyData);
        return null;
      }
      response.json().then((r) => {
        const likeCount = parseInt(r.like_count ? r.like_count : 0);
        if (likeCount >= 0) {
          const bodyData = {
            id: r.id,
            like_count: isActive ? likeCount + 1 : likeCount - 1,
          };
          this.putData(bodyData);
        }
      });
    });

    this.showToolsCount(null);
	  window.dataLayer.push({
		  event: 'click_icon',
		  click_icon: {
			  name: 'like',
			  area: 'body',
			  url: window.location.href,
			  type: 'srdce',
		  },
		  _clear: true,
	  });
  }

  putData = (bodyData) => {
    // eslint-disable-next-line no-undef
    fetch(window.location.origin + fragments.NEWS_PUT_SI, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/components/NewsDetail.js